// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"282":"939a2506","1961":"f41c4528","3035":"d3254480","6749":"939a2506","8811":"939a2506"}[chunkId] + ".chunk.css";
};